import * as moment from 'moment';
import { Moment } from 'moment';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

/**
 * Use this getter any time you want to display the charter date.
 * This exists because the charter date is a DATEONLY field in the database.
 * When the DATEONLY field gets to JavaScript, JavaScript sees that it doesn't
 * have a time, assumes it's UTC, and assigns the offset.
 * There is a corresponding sequelize getter to handle any server side activity.
 * @param dateFormat
 */
export function getUtcCharterDate(
  charter: Charter,
  format: string = 'YYYY-MM-DD',
): Moment {
  return moment.utc(charter.date, format);
}

/**
 * Gets the UTC startMoment and endMoment for a term charter.
 * @param {Charter} charter - The term charter object with date and endDate properties.
 * @param {string} [format='YYYY-MM-DD'] - The format of the date string.
 * @return {{startMoment: Moment, endMoment: Moment}} - The UTC startMoment and endMoment.
 */
export function getUtcTermCharterDate(
  charter: Charter,
  format: string = 'YYYY-MM-DD',
): { startMoment: Moment; endMoment: Moment } {
  return {
    startMoment: moment.utc(charter.date, format),
    endMoment: moment.utc(charter.endDate, format),
  };
}
